<template>
      <ul class="navbar-nav"
         :class="[
            {'footer-list link-list clearfix': bottom},
         ]" >
         <li class="nav-item" v-for="(item, name, index) in menuList" :key="index" @click="onClickMenuItem">
            <a v-if="item.tipo == 'ESTERNO'" :href="item.linkUrl" class="nav-link" target="_blank">{{ item.nome }}</a>
            <router-link v-else
                :to="{path: item.linkUrl }"
                class="nav-link"
                active-class="active"
                exact
            >
                {{ item.nome }}
              </router-link>
         </li>   
      </ul>   
</template>
<script>
export default {
   name: "main-menu",
   props: {
      type: {
         type: String,
         description: "Image"
      },
      menuList: {
         type: Array,
         description: "menuItems in object"
      },      
      levels: {
         type: Number,
         default: 1,
         description: "Number of levels"
      }, 
      bottom: {
         type: Boolean,
         default: false,
         description: "Number of levels"
      }       
   },
   methods: {
         onClickMenuItem () {
         this.$emit('clickedMenuItem', 1);
      }
   } 
};
</script>
<style>
</style>
